<template>
  <figure v-if="image">
    <img
      :src="src"
      :alt="image.alt"
      :title="image.title"
      class="c-residence__image"
    >
  </figure>
</template>

<script>
export default {
  name: 'CardImage',
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
  computed: {
    src() {
      // Get cardImageSize from state
      const imageSize = this.$store.state.entities.images.cardImageSize;
      const sizes = this.image.sizes;
      let src = '';
      // Check which size the user chose for the image and the update src object.
      if (imageSize === 'vertical') {
        src = sizes.find(size => size['name'] === 'preview_vertical');
      } else if (imageSize === 'square') {
        src = sizes.find(size => size['name'] === 'preview_square');
      } else if (imageSize === 'horisontal'){
        src = sizes.find(size => size['name'] === 'preview_horisontal');
      } else {
        src = sizes.find(size => size['name'] === 'medium_large');
      }
      // Return the URL of the image at desired size
      return src.url;
    },
  },
};
</script>
